import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { AppState } from '../../../../@store/app.reducers';
import { ComplementoWebService } from '../../../../services/complemento-web/complemento-web.service';
import { Store } from '@ngrx/store';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { selectDetalleSiniestroSiniestros, selectListaCatalogosSiniestros, selectObjetoDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { MatPaginator } from '@angular/material/paginator';
import { combineLatest, skipWhile, Subscription } from 'rxjs';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { AseguradoTerceroLesionado, ConsultaSiniestroOutput } from 'src/app/models/complementos-web/complementos-web.model';
import { importeMayorACeroValidator } from '../../@validators/validators-complemento';
import { NgClass, SlicePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { PaginaDatosTablaComponent } from '../pagina-datos-tabla/pagina-datos-tabla.component';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { UpperCaseTextDirective } from '../../../../@shared/directives/upper-case.directive';
import { OnlyNumber } from '../../../../@shared/directives/only-number.directive';
import { FormatoNumeroMonedaCoplementoWebDirective } from '../../@directives/formato-numero-moneda.directiva';

@Component({
    selector: 'app-crear-actualizar-ocupantes-asegurado',
    templateUrl: './crear-actualizar-ocupantes-asegurado.component.html',
    styleUrls: ['./crear-actualizar-ocupantes-asegurado.component.scss'],
    imports: [MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, PaginaDatosTablaComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatInput, UpperCaseTextDirective, MatError, OnlyNumber, FormatoNumeroMonedaCoplementoWebDirective, SlicePipe]
})
export class CrearActualizarOcupantesAseguradoComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() public datosAsegurado: MatTableDataSource<any> = new MatTableDataSource([]);

  @Output() eventosOcupantes = new EventEmitter();

  public displayColumns = ['Nombre', 'Estatus', 'Acciones'];

  public detalleSiniestro = null;
  public siniestro: string;
  public detalleSiniestroCompleto: ConsultaSiniestroOutput;
  public lesionadoSeleccionado: AseguradoTerceroLesionado;

  public listaObservables = new Subscription();
  public tamanoResultados: number = 0;
  public formAsegurado: FormGroup;
  public aseguradoSelecciona: AseguradoTerceroLesionado = null;
  public habilitaAsegurado = false;
  public catEstatus = [];
  private formSubscripciones = new Subscription();
  public paginatorInfo = { pageStart: 0, pageEnd: 0 };

  constructor(
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    private procesosComunesService: ProcesosComunesComplementoService,
  ) {
    this.crearFormulario();
    this.obtenerReduxState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['datosAsegurado']?.currentValue) {
    }
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  ngOnInit(): void {
    this.obtenerCatalogos();
    this.cambiosFormulario();
  }

  ngAfterViewInit(): void {
    this.datosAsegurado.paginator = this.paginator;
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleCompleto, detalleBase]) => {
      this.siniestro = siniestro;
      this.detalleSiniestroCompleto = detalleCompleto;
      this.detalleSiniestro = { ...detalleBase };
    });
    this.listaObservables.add(subsComplemento);
  }

  obtenerCatalogos() {
    this.store.select(selectListaCatalogosSiniestros).subscribe({
      next: (value) => {
        this.catEstatus = value.consultaEstatusLesionado;
      },
    });
  }

  crearFormulario() {
    this.formAsegurado = new FormGroup({
      estatus: new FormControl(null, [Validators.required]),
      nombre: new FormControl(null, [Validators.required]),
      apellidoPaterno: new FormControl(null, [Validators.required]),
      apellidoMaterno: new FormControl(null, [Validators.required]),
      edad: new FormControl(null),
      importe: new FormControl(null, [Validators.required, importeMayorACeroValidator()]),
    })
  }

  cambiosFormulario() {
    this.formSubscripciones.unsubscribe();
    this.formSubscripciones = new Subscription();

    const subsTipoOcupante = this.formAsegurado.get('estatus').valueChanges.subscribe({
      next: (value) => {
        if (value == 3) this.formAsegurado.get('importe').setValue(null);

        if ([1, 3, 4].includes(value)) {
          this.formAsegurado.get('nombre').setValidators(Validators.required);
          this.formAsegurado.get('nombre').updateValueAndValidity();
          this.formAsegurado.get('apellidoPaterno').setValidators(Validators.required);
          this.formAsegurado.get('apellidoPaterno').updateValueAndValidity();
          this.formAsegurado.get('apellidoMaterno').setValidators(Validators.required);
          this.formAsegurado.get('apellidoMaterno').updateValueAndValidity();
        } else {
          this.formAsegurado.get('nombre').setValidators(null);
          this.formAsegurado.get('nombre').updateValueAndValidity();
          this.formAsegurado.get('apellidoPaterno').setValidators(null);
          this.formAsegurado.get('apellidoPaterno').updateValueAndValidity();
          this.formAsegurado.get('apellidoMaterno').setValidators(null);
          this.formAsegurado.get('apellidoMaterno').updateValueAndValidity();
        }

        if ([1, 2, 4].includes(value)) {
          this.formAsegurado.get('importe').setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formAsegurado.get('importe').updateValueAndValidity();
        } else {
          this.formAsegurado.get('importe').setValidators(null);
          this.formAsegurado.get('importe').updateValueAndValidity();
        }
      },
    });
    this.formSubscripciones.add(subsTipoOcupante);
  }

  abrirSeccionAsegurado(asegurado?: AseguradoTerceroLesionado) {
    this.habilitaAsegurado = true;
    if (asegurado) {
      this.aseguradoSelecciona = asegurado;
      this.consultarLesionado(this.siniestro, asegurado);
    }
  }

  guardarAsegurado(asegurado?: AseguradoTerceroLesionado) {
    // Validación de campos requeridos
    if (!this.formAsegurado.valid) {
      this.procesosComunesService.alertaGeneralComplemento('Aviso', '', 'warning', false, true, "Debes capturar los campos requeridos");
      return this.formAsegurado.markAllAsTouched();
    }

    if (this.validarRegistro(1, this.detalleSiniestroCompleto.Siniestro[0].respons_sini, this.formAsegurado.get('estatus').value, this.lesionadoSeleccionado?.estatus_tercero ?? "0", this.formAsegurado.get('importe').value)) {
      const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.siniestro);
      const nombreLesionado = `${this.formAsegurado.get('nombre').value}|${this.formAsegurado.get('apellidoPaterno').value}|${this.formAsegurado.get('apellidoMaterno').value}`;
      const request = {
        sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
        linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
        producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
        poliza: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
        endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
        a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
        no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
        cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
        cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
        inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
        num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
        fechaSiniestro: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
        moneda: siniestroFormateado.moneda,
        ramo: siniestroFormateado.ramo,
        sramo: siniestroFormateado.sramo,
        oficina: siniestroFormateado.oficina,
        consecutivo: siniestroFormateado.consecutivo,
        anio: siniestroFormateado.anio,
        tipoCliente: 1,
        id_lesionado: asegurado?.id_lesionado ?? undefined,
        nombre: nombreLesionado,
        edad: this.formAsegurado.get('edad').value,
        // id_tercero: asegurado?.id_tercero ?? 0,
        tipo: this.formAsegurado.get('estatus').value,
        importe: this.formAsegurado.get('importe').value,
        numeroLiga: asegurado?.hospital_lesionado ?? 0,
        proveedor: "",
      }
      console.log(request)
      this.store.dispatch(ActivarLoadingAction());
      this.complementoWebService.guardaActualizaLesionado(request).subscribe({
        next: (value) => {
          this.store.dispatch(DesactivarLoadingAction());
          if (value.Resultado.IdLesionado && value.Exito) {
            this.procesosComunesService.alertaGeneralComplemento('Guardado', `Se guardó/actualizó la información del lesionado correctamente.`, 'success', false, true);
            this.regresaConsulta();
            this.eventosOcupantes.emit();
          } else {
            this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se pudo guardar o actualizar la información.`, 'info', false, true);
          }
        },
        error: (err) => {
          this.store.dispatch(DesactivarLoadingAction());
          this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos procesar el guardado del lesionado' }));
        },
      })
    } else {
      this.formAsegurado.markAllAsTouched();
    }
  }

  eliminarAsegurado(asegurado: AseguradoTerceroLesionado) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.siniestro);
    const request = {
      sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
      linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
      producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
      poliza: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
      endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
      a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
      num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
      fechaSiniestro: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoCliente: 1,
      id_lesionado: asegurado.id_lesionado ?? 0,
      id_tercero: asegurado?.id_tercero ?? 0,
      tipo: asegurado?.tipo ?? 0,
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.eliminaLesionado(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Exito) {
          this.procesosComunesService.alertaGeneralComplemento('Guardado', `La información se eliminó correctamente.`, 'success', false, true);
          this.regresaConsulta();
          this.eventosOcupantes.emit();
        } else {
          this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se pudo eliminar la información.`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos procesar la eliminación del lesionado' }));
      },
    })
  }

  regresaConsulta() {
    this.habilitaAsegurado = false;
    this.catEstatus = [];
    this.aseguradoSelecciona = null;
    this.lesionadoSeleccionado = null;
    this.crearFormulario();
    this.cambiosFormulario();
  }

  setFormulario() {
    const nombreLesionado = this.procesaNombreLesionado();
    this.formAsegurado.patchValue({
      estatus: this.aseguradoSelecciona.tipo,
      nombre: nombreLesionado?.nombre || null,
      apellidoPaterno: nombreLesionado?.apellidoPaterno || null,
      apellidoMaterno: nombreLesionado?.apellidoMaterno || null,
      edad: this.aseguradoSelecciona.edad,
      importe: this.aseguradoSelecciona.importe != "$.00" ? parseFloat(this.aseguradoSelecciona.importe.replace(/[$,]/g, '')) : 0,
    })
  }

  procesaNombreLesionado() {
    if (!this.aseguradoSelecciona.nombre_lesionado) return {
      nombre: null,
      apellidoPaterno: null,
      apellidoMaterno: null,
    }
    const splitNombre = this.aseguradoSelecciona.nombre_lesionado.split("|");
    return {
      nombre: splitNombre[0],
      apellidoPaterno: splitNombre[1],
      apellidoMaterno: splitNombre[2],
    }
  }

  consultarLesionado(siniestro: string, lesionado: AseguradoTerceroLesionado) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoCliente: 1,
      id_lesionado: lesionado.id_lesionado
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaLesionados(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado.Lesionado.length) {
          this.lesionadoSeleccionado = value.Resultado.Lesionado[0];
          this.setFormulario();
          const esHospital = this.lesionadoSeleccionado.hospital_lesionado == 1;
          // Importe y campos de lesionado
          const disable = this.lesionadoSeleccionado.hospital_lesionado > 0;
          if (disable) {
            this.formAsegurado.get('importe')?.disable();
            if (this.lesionadoSeleccionado.tipo_prestador === 21) {
              this.formAsegurado.get('edad')?.disable();
            }
          } else {
            this.formAsegurado.get('importe')?.enable();
            this.formAsegurado.get('estatus')?.enable({ emitEvent: false });
          }

          if (esHospital == false) {
            this.formAsegurado.get('estatus')?.disable({ emitEvent: false });
          }
        } else {
          // this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se encontró ningun asegurado`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener el detalle del lesionado.' }));
      },
    })
  }

  validarRegistro(tipoCliente: number, responsable: number, estatusOcupante: number, estatusTercero: string, importe: string): boolean {
    // Validación 1: Tercero sin estatus válido
    if (tipoCliente === 2 && responsable === 2 && estatusOcupante !== 3) {
      if (estatusTercero !== '5' && estatusTercero !== '6') {
        this.procesosComunesService.alertaGeneralComplemento(
          'Validación de Tercero',
          'No se puede Guardar/Actualizar el registro debido a que el responsable es el tercero y el tercero seleccionado no tiene estatus MP o JUEZ CÍVICO.',
          'warning',
          false,
          true
        );
        return false;
      }
    }

    // Validación 2: Importe no válido
    if (importe?.length) {
      const importeNumerico = parseFloat(importe.replace(/,/g, ''));
      if (importeNumerico <= 0) {
        this.procesosComunesService.alertaGeneralComplemento(
          'Validación de Importe',
          'No se puede guardar/actualizar debido a que el importe tiene que ser mayor a cero.',
          'warning',
          false,
          true
        );
        return false;
      }
    }

    return true; // Todo correcto
  }

  validaEliminacion(asegurado: AseguradoTerceroLesionado) {
    this.procesosComunesService.alertaGeneralComplemento(
      'Aviso!',
      '¿Está seguro que desea eliminar el registro?.',
      'question',
      true,
      true
    ).then(result => {
      if (result.isConfirmed) {
        this.eliminarAsegurado(asegurado);
      }
    });
  }

}
